import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { loadGoogleMapsPlaces } from './app/shared/utils/google-maps-loader';
import 'leaflet.markercluster';

loadGoogleMapsPlaces().catch(() => undefined);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
